module.exports = __webpack_public_path__ + "static/media/Engpic1.0504e120.png";